import React from 'react';

import { useSelector } from 'react-redux';

import { selectIsMobile } from 'selectors/ui';

import SkuPayoutReportsListDesktop from './SkuPayoutReportsListDesktop';
import SkuPayoutReportsListMobile from './SkuPayoutReportsListMobile';

const SkuPayoutReportsList = () => {
  const isMobile = useSelector(selectIsMobile);
  return isMobile ? <SkuPayoutReportsListMobile /> : <SkuPayoutReportsListDesktop />;
};

export default SkuPayoutReportsList;
